import { createSlice } from "@reduxjs/toolkit";
import { apiSlice } from "../../../app/service/Service";

export const userSignUpSlice = apiSlice.injectEndpoints({
  endpoints: builder => ({
    userSignUp: builder.mutation({
        query: (body) => ({
          url: `Account/UserRegistration`,
          method: "POST",
          body,
        }),
      }),

      existingUser: builder.mutation({
        query: (email , ...body) => ({
          url: `Account/UserExistance?email=${email}`,
          method: "POST",
          body
        }),
      }),

      existingUserName: builder.mutation({
        query: (userName , ...body) => ({
          url: `Account/UserExistance?userName=${userName}`,
          method: "POST",
          body
        }),
      }),

    })
})

export const { useUserSignUpMutation, useExistingUserMutation , useExistingUserNameMutation} = apiSlice;

